import { EffectCallback, useEffect } from "react";

export function useSingleEffect(effect: EffectCallback): void {
  return useEffect(() => {
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
